import { token } from '@atlaskit/tokens';
import { type StylesConfig } from '@databases/atlaskit/Select';

export const baseSelectStyleConfig: StylesConfig<any> = {
  menu: (base) => ({
    ...base,
    width: '100%',
    minWidth: '260px',
    position: 'relative',
    boxShadow: 'none',
    margin: '0',
  }),
  menuList: (base) => ({
    ...base,
    padding: '0',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0',
  }),
  control: (base) => ({
    ...base,
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    paddingLeft: token('space.150', '.75rem'),
    paddingRight: token('space.150', '.75rem'),
    // Override @atlaskit/select's font.body.large to match the cell's 14px font size.
    font: token('font.body', '14px'),
  }),
  placeholder: (base) => ({
    ...base,
    left: token('space.300', '1.5rem'),
    paddingLeft: token('space.150', '.75rem'),
    overflow: 'hidden',
    position: 'absolute',
    width: 'calc(100% - 1.5rem)',
  }),
  input: (base) => ({
    ...base,
    overflow: 'hidden',
    position: 'absolute',
    width: 'calc(100% - 1.5rem)',
    marginLeft: token('space.100', '0.5rem'),
    // Override @atlaskit/select's font.body.large to match the cell's 14px font size.
    font: token('font.body', '14px'),
  }),
  option: (base) => ({
    ...base,
    // Override @atlaskit/select's font.body.large to match the cell's 14px font size.
    font: token('font.body', '14px'),
  }),
};

export const isRenderedInSidePanelStyling: StylesConfig<any> = {
  menu: (base) => ({
    ...base,
    width: '100%',
    minWidth: '260px',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0',
  }),
  control: (base) => ({
    ...base,
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    border: 'none',
    // Override @atlaskit/select's font.body.large (16px) on narrow viewports
    // to prevent iOS Safari zoom. Match the cell's 14px font size.
    fontSize: '14px',
  }),
  placeholder: (base) => ({
    ...base,
    paddingLeft: token('space.150', '.75rem'),
  }),
  input: (base) => ({
    ...base,
    marginLeft: token('space.150', '.75rem'),
    '> div > input': {
      width: '100% !important',
    },
    // Override @atlaskit/select's font.body.large (16px) on narrow viewports
    // to prevent iOS Safari zoom. Match the cell's 14px font size.
    fontSize: '14px',
  }),
  option: (base) => ({
    ...base,
    // Override @atlaskit/select's font.body.large (16px) on narrow viewports
    // to prevent iOS Safari zoom. Match the cell's 14px font size.
    fontSize: '14px',
  }),
};

export const customPlaceholderAndControlSpacingStyling: StylesConfig<any> = {
  placeholder: (base) => ({
    ...base,
    left: 'auto',
    marginLeft: token('space.150', '.75rem'),
    position: 'relative',
    overflow: 'visible',
    width: 'auto',
  }),
  valueContainer: (base) => ({
    ...base,
    display: 'flex',
    paddingLeft: token('space.150', '.75rem'),
  }),
  input: (base) => ({
    ...base,
    position: 'relative',
    overflow: 'visible',
    width: 'auto',
    marginLeft: '-0.3rem',
    // Override @atlaskit/select's font.body.large to match the cell's 14px font size.
    font: token('font.body', '14px'),
  }),
  control: (base) => ({
    ...base,
    paddingLeft: 0,
    paddingRight: 0,
    // Override @atlaskit/select's font.body.large to match the cell's 14px font size.
    font: token('font.body', '14px'),
  }),
};
